export const getInitialValues = (product, colorId) => {
  const { variants = [] } = product;
  let defaultVariant = variants.find(x => x.default)?._id;

  if (!defaultVariant) {
    defaultVariant = variants[0]?._id;
  }

  const { colors = [] } = product;

  const color = colors.find(x => x._id === colorId);

  return {
    variantId: defaultVariant,
    colorId: colorId ? color.hex : product?.colors?.[0]?.hex ?? null,
    quantity: product?.quantity?.minQuantity ?? 1,
    note: '',
  };
};

export const AVAILABLE_TYPE = {
  FINITE    : 'finite',
  IN_FINITE : 'infinite',
};